import React from 'react';
import { t } from '@lingui/macro';
import { FileRenderer_node$data } from '../__generated__/FileRenderer_node.graphql';
import { contentFromNode } from '..';
import { UnsupportedFileRenderer } from '../UnsupportedFileRenderer';

interface VideoFileRendererProps {
  node: FileRenderer_node$data;
}

export const VideoFileRenderer = ({ node }: VideoFileRendererProps) => {
  const { mimeType, url } = contentFromNode(node);

  return url ? (
    <div
      style={{
        display: 'flex',
        flex: 1,
        backgroundColor: 'black',
        color: 'white',
      }}
      data-chromatic="ignore"
    >
      <video
        style={{ width: '100%', maxHeight: '100%' }}
        controls
        preload="auto"
      >
        <source src={url} />
        {t`Your browser does not support this video.`}
      </video>
    </div>
  ) : (
    <UnsupportedFileRenderer node={node} />
  );
};
